import axios from '@/api/config';

const applyGuide = {
  getApplyGuide(data) {
    return axios.get(`${process.env.BASE_URL}/applyGuide/getApplyGuide`, { params: data });
  },
  addOrUpdateApplyGuide(data) {
    return axios.post(`${process.env.BASE_URL}/applyGuide/addOrUpdateApplyGuide`, data);
  },
  updateApplyGuideStatus(data) {
    return axios.get(`${process.env.BASE_URL}/applyGuide/updateApplyGuideStatus`, { params: data });
  },
  // pageList(data) {
  //   return axios.post(`${process.env.BASE_URL}/applyGuide/pageList`, data);
  // },



}

export default applyGuide;



// WEBPACK FOOTER //
// ./src/api/applyGuide.js